/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo } from "react";
import ApexCharts from "apexcharts";

export function MixedWidget0({ className, data }) {

  const layoutProps = useMemo(() => {
    return {
      strokeColor: "#D13647",
      fontFamily: "Arial, sans-serif",
    };
  }, []);

  let attendedRates = [];
  let absentRates = [];
  let categories = [];


  useEffect(() => {
    const element = document.getElementById("attendance_chart");
    if (!element) return;

    attendedRates = data.map(i => {
      const total = i?.total_employees ?? 0;
      if (total === 0) return 0;
      return total === 0 ? 0 : Number(((i.attended_employees / total) * 100).toFixed(0));
    });

    absentRates = data.map(i => {
      const total = i?.total_employees ?? 0;
      if (total === 0) return 0;
      return total === 0 ? 0 : Number(((i.absent_employees / total) * 100).toFixed(0));
    });
    categories = data.map(i => i.name ?? "Unknown");

    const options = {
      series: [
        {
          name: "In",
          data: attendedRates,
        },
        {
          name: "Out",
          data: absentRates,
        },
      ],
      chart: {
        type: "bar",
        height: 330,
        width: data.length * 50,//"100%",
        stacked: true,
        toolbar: {
          show: true,
          export: {
            csv: {
              filename: "AttendanceReport",
            },
            svg: {
              filename: "AttendanceReport",
            },
            png: {
              filename: "AttendanceReport",
            },
          },
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          const index = opts.dataPointIndex;
          if (!data || !data[index]) return 0;

          if (opts.seriesIndex === 0) {
            return data[index]?.attended_employees ?? 0;
          } else {
            return data[index]?.absent_employees ?? 0;
          }
        },
      },
      xaxis: {
        categories: categories,
        labels: {
          rotate: -45,
          formatter: function (val) {
            const maxLength = 15;
            return val.length > maxLength ? val.substring(0, maxLength) + "..." : val;
          },
          style: {
            fontSize: "12px",
            fontFamily: layoutProps.fontFamily,
          },
        },
        tooltip: {
          enabled: true,
        },
      }
      ,
      yaxis: {
        max: 100,
        labels: {
          formatter: (val) => `${val}%`,
        },
      },
      tooltip: {
        y: {
          formatter: (val) => `${val}%`,
        },
      },
      colors: ["#00E396", "#FF4560"],
      legend: { position: "top" },
    };

    const chart = new ApexCharts(element, options);
    chart.render();

    return () => chart.destroy();
  }, [layoutProps, data]);

  if (!data || data.length === 0) {
    return (
      <div className={`card card-custom p-2 ${className}`} >
        <h3 className="text-center mb-3 text-uppercase">Rate of Absence</h3>
        <div className="p-4 text-center text-muted">No data available yet</div>
      </div>
    );
  }

  return (
    <div className={`card card-custom p-2  ${className}`}>
      <h3 className="text-center mb-3 text-uppercase">Rate of Absence</h3>
      <div className="card-body p-0 position-relative overflow-hidden" style={{ height: "100%" }}>
        <div id="attendance_chart" style={{ width: "100%", height: "100%" }} className="card-body p-0 position-relative overflow-auto"
        ></div>
      </div>
    </div>
  );
}
